import { render, staticRenderFns } from "./RegisterInternationalFund.vue?vue&type=template&id=824d151e&scoped=true&"
import script from "./RegisterInternationalFund.vue?vue&type=script&lang=js&"
export * from "./RegisterInternationalFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824d151e",
  null
  
)

export default component.exports